import {
	REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS,
	RECEIVE_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS,
	RECEIVE_BAD_REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS
} from "../actions/index";

const defaultState = {
	transitions: [],
	fetching: false,
	badFetchResponse: ''
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS:
			return {
				...state,
				fetching: true
			};
		case RECEIVE_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS:
			return {
				...state,
				fetching: false,
				transitions: action.payload
			};
		case RECEIVE_BAD_REQUEST_GET_APPLICATION_ACCEPTED_STATUSES_TRANSITIONS:
			return {
				...state,
				fetching: false,
				badFetchResponse: action.payload
			};
		default:
			return state
	}
}